import React,{useState,useEffect} from 'react';
import Header from '../../components/common/Header';
import AccountDetail from '../../components/Student/AccountDetail';
import BankTransferForm from '../../components/Student/BankTransferForm';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';
import LoaderImg from '../../assets/images/loader.gif'
import { useNavigate,useLocation, useParams} from 'react-router-dom';
import { getCashWinnerBankDetailStatus, getOfflinePaymentTypes, getSelectedDetail } from '../../actions/StudentAction';
import StudentBankDetail from '../../components/Student/StudentBankDetail';
import {Link} from 'react-router-dom'



const BankDetail = (props) => {
    const navigate = useNavigate();
    const useParam = useParams();
    const location=useLocation();
    const [detail,setDetail] = useState();
    const [showForm,setShowForm] = useState();
    const [loading,setLoading] = useState(true)
 
    // useEffect(() => {
    //     // sessionStorage.getItem('userDetail') ?  navigate(`bank-detail/`) : navigate('/login');
    //     // if(location&& location.state!==null){
    //     //     const {detail,feeDetail,payType}=location.state
    //     //     const userId=detail.id
    //     //     setDetail(detail)
    //     // }
 
    // },[location.state]);

    useEffect(async()=>{
        sessionStorage.getItem('userDetail') ?  navigate(`/bank-detail/${useParam?.id !==undefined && useParam?.id}`) : navigate('/login');
        getSelectedDetail(useParam?.id).then((res) => {
              setLoading(true)
            if(res.status){
                setDetail(res.data);
              setLoading(false)
            }
          });

          getCashWinnerBankDetailStatus(detail?.form_num).then((res) => {
            setLoading(true)
            if(res.status){
                setShowForm(true)
                setLoading(false)
            }
            else{
                setShowForm(false)
                setLoading(false)
            }
          })
         
         
    },[useParam?.id,detail?.form_num])

 


    

  return (
     <>
      {loading ? <div className="screenLoader text-center flex-wrap">
      <img src={LoaderImg} alt="Loading..." style={{width:'140px'}}/>
      {/* <h6 className="d-block w-100 text-black fw-bold mb-2">Loading</h6>
      <ReactLoading type={"cubes"} className="flex-shrink-1" width={60} height={50}  color={"#20367f"}/> */}
      </div>:
      <>
      <Header detail={detail}/>
      <section className="pt-5 pb-5 content-section">
        <div className="container">
            <PageBreadcrumbs  profileDetailLink={detail} pagename="Bank Transfer" />  
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="register-box">
                        <div className='allenAccountDetaiWrap border p-3 mb-4 rounded text-center'>
                            <h4 className='mb-3'>TALLENTEX Overseas 2023 Cash Prize Winners</h4>
                            <p>Congratulations to all the students who have won Cash Prize in the biggest talent <br/>encouragement cum scholarship exam - 
                                <strong>𝐓𝐀𝐋𝐋𝐄𝐍𝐓𝐄𝐗 𝐎𝐯𝐞𝐫𝐬𝐞𝐚𝐬 𝟐𝟎𝟐𝟑</strong>.</p>
                            <p><strong>Keep striving for greatness!</strong>.</p>

                         
                        </div>
                        <div className="alert alert-warning" role="alert">
                            <b>NOTE</b> : Please fill the details to receive your cash reward. 
                                In case of any queries, write to us at overseascontact@tallentex.com <br/>or contact your respective country representative.
                        </div>
                        {showForm ?
                        <>
                        <div className='card my-3 py-3'>
                            <div className='row px-4'>
                            
                                {/* <div className='col-md-3'>
                                    <h6>Country</h6>
                                    <h5 className='text-black h6 fw-bold'>{detail?.country.toLowerCase()}</h5>
                                </div> */}
                                <div className='col-md-3'>
                                    <h6>From Number</h6>
                                    <h5 className='text-black h6 fw-bold'>{detail?.form_num}</h5>
                                </div>
                                <div className='col-md-3'>
                                    <h6>Name</h6>
                                    <h5 className='text-black h6 fw-bold'>{detail?.name}</h5>
                                </div>
                                <div className='col-md-3'>
                                    <h6>Parent Name <span className='text-danger fw-bold fs-5 mb-0'>*</span></h6>
                                    {detail?.father_name !== null ? 
                                    <h5  className='text-black h6 fw-bold'>{detail?.father_name}</h5>
                                    :
                                    <Link to="/dashboard"  state={{detail:detail}}  className='d-inline-block btn ms-auto btn-sm  btn-warning'>Go to family detail section</Link>
                                    }
                                    
                                    
                                </div>
                                
                            </div>
                        </div>
                        <StudentBankDetail  detail={detail}/>
                        </>
                        :
                        <div className='bank-detail-submitted mt-5'>
                            <h3 className='text-success text-center fw-bold'>You have successfully submitted bank details form.</h3>
                            </div>

                    }
   
                    </div>
                </div>
            </div>
        </div>
        </section>
    </>
      }
    </>
    
  )
}

export default BankDetail
